import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAllActivityGroup,
  getAllOrganization,
  getAllProduct,
  getAllSector,
  getAllSubSector,
  getAllUnit,
} from "./crud";
import {
  getAllCity,
  getAllPart,
  getAllRuralArea,
  getAllTownship,
  getAllVillage,
} from "./partsCrud";

const initialState = {
  townships: undefined,
  parts: undefined,
  cities: undefined,
  villages: undefined,
  organizations: undefined,
  units: undefined,
  ruralAreas: undefined,
  status: "idle",
};

export const ruralAreaFetch = createAsyncThunk(
  "part/fetchRuralAreas",
  async (params) => {
    const response = await getAllRuralArea(params);
    return response.data.data;
  }
);

export const townshipFetch = createAsyncThunk(
  "part/fetchTownships",
  async (params) => {
    const response = await getAllTownship(params);

    return response.data.data;
  }
);

export const partFetch = createAsyncThunk("part/fetchParts", async (params) => {
  const response = await getAllPart(params);

  return response.data.data;
});

export const cityFetch = createAsyncThunk(
  "part/fetchCities",
  async (params) => {
    const response = await getAllCity(params);

    return response.data.data;
  }
);

export const villageFetch = createAsyncThunk(
  "part/fetchVillages",
  async (params) => {
    const response = await getAllVillage(params);

    return response.data.data;
  }
);

export const organizationFetch = createAsyncThunk(
  "part/fetchOrganizations",
  async (params) => {
    const response = await getAllOrganization(params);

    return response.data.data;
  }
);

export const unitFetch = createAsyncThunk("part/fetchUnits", async (params) => {
  const response = await getAllUnit(params);

  return response.data.data;
});

export const setParts = createAction("part/setParts", (action) => {
  return { payload: action };
});

export const setCities = createAction("part/setCities", (action) => {
  return { payload: action };
});

export const setVillages = createAction("part/setVillages", (action) => {
  return { payload: action };
});

export const setRuralAreas = createAction("part/setRuralAreas", (action) => {
  return { payload: action };
});

export const setUnits = createAction("part/setUnits", (action) => {
  return { payload: action };
});

export const partClear = createAction("part/partClear", (action) => {
  return { payload: action };
});

export const ruralAreaClear = createAction("part/ruralAreaClear", (action) => {
  return { payload: action };
});

export const cityClear = createAction("part/cityClear", (action) => {
  return { payload: action };
});

export const villageClear = createAction("part/villageClear", (action) => {
  return { payload: action };
});

export const organizationClear = createAction(
  "part/organizationClear",
  (action) => {
    return { payload: action };
  }
);

export const unitClear = createAction("part/unitClear", (action) => {
  return { payload: action };
});

export const part = createSlice({
  name: "part",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(townshipFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(townshipFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.townships = action.payload;
      });

    builder
      .addCase(partFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(partFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.parts = action.payload;
      });

    builder
      .addCase(cityFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(cityFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.cities = action.payload;
      });

    builder
      .addCase(villageFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(villageFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.villages = action.payload;
      });

    builder
      .addCase(ruralAreaFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(ruralAreaFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.ruralAreas = action.payload;
      });

    builder
      .addCase(unitFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(unitFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.units = action.payload;
      });

    builder
      .addCase(organizationFetch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(organizationFetch.fulfilled, (state, action) => {
        state.status = "idle";
        state.organizations = action.payload;
      });

    builder.addCase(setParts, (state, action) => {
      state.parts = action.payload;
    });

    builder.addCase(setCities, (state, action) => {
      state.cities = action.payload;
    });

    builder.addCase(setVillages, (state, action) => {
      state.villages = action.payload;
    });

    builder.addCase(setRuralAreas, (state, action) => {
      state.ruralAreas = action.payload;
    });

    builder.addCase(setUnits, (state, action) => {
      state.units = action.payload;
    });

    builder.addCase(partClear, (state, action) => {
      state.parts = action.payload;
    });

    builder.addCase(cityClear, (state, action) => {
      state.cities = action.payload;
    });
    builder.addCase(ruralAreaClear, (state, action) => {
      state.ruralAreas = action.payload;
    });
    builder.addCase(villageClear, (state, action) => {
      state.villages = action.payload;
    });
    builder.addCase(unitClear, (state, action) => {
      state.units = action.payload;
    });
    builder.addCase(organizationClear, (state, action) => {
      state.organizations = action.payload;
    });
  },
});

export const selectPartList = (state) => state.part;

export default part.reducer;
